<link rel="stylesheet" type="text/css" href="https://marvelapp.github.io/devices.css/assets/devices.min.css" />
<style>
    .header .status {
        justify-content: space-between;
        display: flex;
    }
    .title {
        text-align: center;
    }
    .title span.back {
        float: left;
        cursor: pointer;
    }
    .title span {
        display: inline-block;
    }
    label {
        display: block;
    }
</style>
<select [formControl]="device">
    <option ngValue="iphone8">iphone8</option>
    <option ngValue="iphone8plus">iphone8plus</option>
    <option ngValue="iphone5s">iphone5s</option>
    <option ngValue="iphone5c">iphone5c</option>
    <option ngValue="iphone4s">iphone4s</option>
    <option ngValue="nexus5">nexus5</option>
    <option ngValue="s5">s5</option>
    <option ngValue="lumia920">lumia920</option>
    <option ngValue="ipad">ipad</option>
    <option ngValue="macbook">macbook</option>
    <option ngValue="iphone-x">iphone-x</option>
    <option ngValue="note8">note8</option>
</select>
<hr />
<div class="marvel-device {{ device.value }}">
    <div class="notch">
        <div class="camera"></div>
        <div class="speaker"></div>
    </div>
    <div class="top-bar"></div>
    <div class="sleep"></div>
    <div class="bottom-bar"></div>
    <div class="volume"></div>
    <div class="overflow">
        <div class="shadow shadow--tr"></div>
        <div class="shadow shadow--tl"></div>
        <div class="shadow shadow--br"></div>
        <div class="shadow shadow--bl"></div>
    </div>
    <div class="inner-shadow"></div>
    <div class="screen">
        <div class="header">
            <div class="status"><span>No SIM</span><span>13:22</span><span>42%</span></div>
            <div class="title">
                @if (navigation()?.back) {
                    <span class="back" (click)="goBack()" (keyup.enter)="goBack()" data-bb="navigation" tabindex="0">< Vorige</span>
                }
                @if (title()) {
                    <span data-bb="title">{{ title() }}</span>
                }
                <span></span>
            </div>
        </div>
        <iframe
            [hidden]="signPayload() || showSettings"
            #iframe
            [src]="safeUrl"
            width="100%"
            height="85%"
            title="FEP application"
            id="fepApplication"
        ></iframe>

        @if (signPayload()) {
            <div>
                <pre>{{ signPayload().data | json }}</pre>
                <button data-bb="signingDone" (click)="signingDone()">SigningDone</button>
                <button data-bb="signingCancelled" (click)="signingCancelled()">SigningCancelled</button>
            </div>
        }
        @if (!showSettings) {
            <div (click)="showSettings = true" (keyup.enter)="showSettings = true" data-bb="showSettings" tabindex="1">Settings</div>
        }
        @if (showSettings) {
            <div class="settings">
                <p>This is the data that is held by this native app. Change the inputs below, after a page refresh all values are reset.</p>
                <label>selectedAccount<input type="text" [formControl]="selectedAccount" /></label>
                <label>selectedIdentification<input type="text" [formControl]="selectedIdentification" /></label>
                <label>selectedDebitCard iban<input type="text" [formControl]="selectedDebitCard.get('iban') | apFormControl" /></label>
                <label
                    >selectedDebitCard sequence number<input
                        type="text"
                        [formControl]="selectedDebitCard.get('sequenceId') | apFormControl"
                /></label>
                <label>appearanceSetting <input type="text" [formControl]="appearanceSetting" /></label>
                <div>
                    @if (finishProcess()) {
                        <button data-bb="finishProcess" (click)="finishProcess.set(undefined)">
                            Finish process: {{ finishProcess() }}
                        </button>
                    }
                    @if (logOut()) {
                        <button data-bb="logOut" (click)="logOut.set(undefined)" tabindex="2">Log out</button>
                    }
                </div>
                <p (click)="showSettings = false" (keyup.enter)="showSettings = false" tabindex="3">close</p>
            </div>
        }
    </div>
</div>
